import axios from 'axios';
import { API_URL } from '../config/apiConfig';
import type { Anomaly, AnomalyListResponse, AnomalyStatistics, ResolveAnomalyRequest } from '../types/anomaly';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const API_PREFIX = '/api/v1/hotel';

export const anomalyService = {
  // Get all unresolved anomalies
  async getUnresolvedAnomalies(): Promise<AnomalyListResponse> {
    const response = await api.get(`${API_PREFIX}/anomalies`);
    return response.data;
  },

  // Get single anomaly by ID
  async getAnomalyById(id: string): Promise<Anomaly> {
    const response = await api.get(`${API_PREFIX}/anomalies/${id}`);
    return response.data;
  },

  // Resolve an anomaly
  async resolveAnomaly(id: string, data: ResolveAnomalyRequest): Promise<void> {
    await api.put(`${API_PREFIX}/anomalies/${id}/resolve`, data);
  },

  // Get anomaly statistics
  async getStatistics(): Promise<AnomalyStatistics> {
    const response = await api.get(`${API_PREFIX}/anomalies/statistics`);
    return response.data;
  },

  // Trigger anomaly detection manually
  async triggerDetection(): Promise<void> {
    await api.post(`${API_PREFIX}/anomalies/detect`);
  },

  // Get scheduler status
  async getSchedulerStatus(): Promise<{ running: boolean }> {
    const response = await api.get(`${API_PREFIX}/anomalies/scheduler/status`);
    return response.data;
  },
};
